import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LandingService } from './services/landing.service';
import { RequestDemo } from './interfaces/landing.interfaces';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingPageComponent implements OnInit {
  demoForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;
  submitError = false;
  submitErrorMessage = '';

  fieldLabels: { [key: string]: string } = {
    email: 'Business Email Address',
    firstName: 'First Name',
    lastName: 'Last Name',
    company: 'Company Name',
    title: 'Job Title',
    country: 'Country',
    newsletter: 'Newsletter Subscription',
  };

  constructor(
    private fb: FormBuilder,
    private landingService: LandingService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.demoForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      company: ['', Validators.required],
      title: ['', Validators.required],
      country: ['', Validators.required],
      newsletter: [false],
    });

    this.demoForm.valueChanges.subscribe(() => {
      this.clearSubmitError();
    });
  }

  handleDemoRequest(): void {
    if (this.demoForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      this.submitError = false;
      this.submitErrorMessage = '';

      const requestData: RequestDemo = this.demoForm.value;

      this.landingService.requestDemo(requestData).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          this.isSubmitted = true;
          // this.demoForm.reset();
          //
          // setTimeout(() => {
          //   this.isSubmitted = false;
          // }, 3000);
        },
        error: (error) => {
          this.isSubmitting = false;
          this.submitError = true;
          this.submitErrorMessage =
            'Request could not be sent due to an error. Please try again.';
        },
      });
    } else {
      this.markFormGroupTouched();
    }
  }

  private markFormGroupTouched(): void {
    Object.keys(this.demoForm.controls).forEach((key) => {
      this.demoForm.get(key)?.markAsTouched();
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.demoForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  getFieldError(fieldName: string): string {
    const field = this.demoForm.get(fieldName);
    const fieldLabel = this.getFieldLabel(fieldName);

    if (field?.errors) {
      if (field.errors['required']) {
        return `${fieldLabel} is required`;
      }
      if (field.errors['email']) {
        return 'Please enter a valid email address';
      }
    }
    return '';
  }

  getFieldLabel(fieldName: string): string {
    return this.fieldLabels[fieldName] || fieldName;
  }

  getSubmitButtonText(): string {
    if (this.isSubmitting) {
      return 'Sending...';
    }
    if (this.isSubmitted) {
      return 'Thank you for your interest, we will be in touch ASAP!';
    }
    return 'Send Request';
  }

  isSubmitDisabled(): boolean {
    return this.isSubmitting || this.isSubmitted;
  }

  clearSubmitError(): void {
    if (this.submitError) {
      this.submitError = false;
      this.submitErrorMessage = '';
    }
  }
}
